import React from 'react';

const Mission = () => {
  return (
    <div id="Mission" className="Mission-page">
      <p className='Mission'>Our  <span> Mission</span></p>

      <div className='Mission-box'>
        <p className='Mission-para'>Araniko's mission is to unveil Nepal's hidden beauty to the world bey empowering users to independently explore its cultural sites. Through innovation technologies and sustainable practices, Araniko aims to foster appreciation,curiosity, and a lasting connection to Nepal's diverse cultural heritage. By providing resources and virtual experiences, Araniko enables individuals to experience the wonders of Nepal firsthand and promotes responsible tourism for the preservation of these sites.  </p>
      </div>
    </div>
  );
}

export default Mission;